<template>
    <div class="app">
        <Header label="My Pools"/>
        <div class="questions-content" id="create-pool">
            <div class="header">
                WaterGuru Setup Questions
            </div>
            <w-questions class="mt-0 offset"
                         button-text="Create pool"
                         @save="submit"
                         :changed="true"
                         :message-show="message.text"
                         :message-text="message.text"
                         :message-type="message.type"
                         :sections="['pool_name', 'other_questions', 'equipment', 'address', 'gallons']"/>
        </div>
        <w-version/>
    </div>
</template>

<script>
import Header from '../Header'
import { lambda } from '../../amplify'
import { mapGetters } from 'vuex'

export default {
    name: 'Create',
    data () {
        return {
            waterBody: { state: '' },
            message: {
                text: '',
                type: ''
            }
        }
    },
    components: {
        Header: Header
    },
    computed: {
        ...mapGetters({
            pools: 'pools/pools'
        })
    },
    methods: {
        submit (data) {
            this.message.text = ''
            this.message.type = ''
            const waterBody = Object.keys(data).reduce((obj, key) => {
                if (data[key] !== '' && key !== 'measDoseHr' && key !== 'measDoseMin') {
                    obj[key] = data[key]
                }
                if (key === 'zip') {
                    obj[key] = parseInt(data[key])
                }
                return obj
            }, {})

            lambda('createWaterBody', {
                userId: this.$store.getters['auth/user'].username,
                waterBody
            }).then(data => {
                if (data.code === 'OK') {
                    this.$router.push({ path: '/' }).catch(e => e)
                    // this.$router.push('/')
                } else if (data.code === 'WATER_BODY_LABEL_EXISTS') {
                    this.message.text = 'You already have a pool with this name'
                    this.message.type = 'danger'
                }
            })
        }
    }
}
</script>

<style scoped>
    select, select:hover {
        outline: 0 !important;
        -webkit-appearance: none;
    }

    .header {
        padding: 20px 15px 15px;
        margin-left: 25%;
        margin-right: 40%;
        font-size: 30px;
        text-align: center;
    }

    .questions-content {
        margin-top: 85px;
        padding-left: 25%;
        padding-right: 25%;
    }

    @media (max-width: 576px) {
        .header {
            margin-bottom: 0;
            margin-left: 0;
            margin-right: 0;
        }

        .questions-content {
            padding-left: 17px;
            padding-right: 17px;
        }
    }
</style>
